import { RaRecord } from "react-admin";

export type SitePowerBounds = {
  min_power_mw: number;
  max_power_mw: number;
};

export const getSitePowerBounds = (nominalPower: unknown): SitePowerBounds | null => {
  if (typeof nominalPower !== "number" || !Number.isFinite(nominalPower) || nominalPower <= 0) {
    return null;
  }
  return { min_power_mw: -nominalPower, max_power_mw: nominalPower };
};

export const isSitePendingSynchronization = (currentSite: RaRecord | undefined) => {
  if (!currentSite) return false;
  return (
    !currentSite?.desired_configuration ||
    !currentSite?.reported_configuration ||
    currentSite?.desired_configuration?.id !== currentSite?.reported_configuration?.id
  );
};
